/* @flow */
/* eslint-disable babel/no-invalid-this */
import followLink from "nexia_mobile/models/followLink";
import type { DragonflyWifiConfigurationFeature } from "./types";

export default function DragonflyWifiConfiguration(
  feature: DragonflyWifiConfigurationFeature
) {
  this.fetchLastUpdateTime = () => {
    return followLink(this, feature.get_last_update_time, {
      silent: true,
    }).then((data) => data.last_update_time && new Date(data.last_update_time));
  };

  return {};
}



// WEBPACK FOOTER //
// ./src/models/mixins/device_features/dragonfly_wifi_configuration.js